import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Chave de acesso',
        field: 'chave_acesso'
      }, {
        type: 'text',
        label: 'Fornecedor',
        field: 'fornecedor'
      }, {
        type: 'date',
        label: 'Data emissão',
        field: 'data_emissao'
      }]
    }
  }), _c('b-dropdown', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.menuAcoes",
      modifiers: {
        "menuAcoes": true
      }
    }, {
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "mb-2",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.monitorarModal",
      modifiers: {
        "monitorarModal": true
      }
    }]
  }, [_vm._v("Monitorar NFes")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.monitorarByChaveModal",
      modifiers: {
        "monitorarByChaveModal": true
      }
    }]
  }, [_vm._v("Monitorar via chave de acesso")])], 1), _c('b-modal', {
    attrs: {
      "id": "monitorarByChaveModal",
      "title": "Deseja monitorar via chave de acesso?",
      "centered": "",
      "size": "lg",
      "hide-footer": ""
    }
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Informe a chave de acesso",
      "label-for": "chaveDeAcesso"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "44",
      "minlength": "44",
      "autofocus": ""
    },
    model: {
      value: _vm.chaveDeAcesso,
      callback: function callback($$v) {
        _vm.chaveDeAcesso = $$v;
      },
      expression: "chaveDeAcesso"
    }
  })], 1)], 1)], 1), _c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-button', {
    ref: "monitorar_ByChave",
    staticClass: "mr-5",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.manitorarByChave
    }
  }, [_vm._v(" Sim ")]), _c('b-button', {
    on: {
      "click": function click() {
        return _vm.$bvModal.hide('monitorarByChaveModal');
      }
    }
  }, [_vm._v(" Não ")])], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "monitorarModal",
      "title": "Deseja consultar?",
      "centered": "",
      "size": "sm",
      "hide-footer": ""
    }
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-button', {
    ref: "consultar_manifestos",
    staticClass: "mr-5",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.manifestar
    }
  }, [_vm._v(" Sim ")]), _c('b-button', {
    on: {
      "click": function click() {
        return _vm.$bvModal.hide('monitorarModal');
      }
    }
  }, [_vm._v(" Não ")])], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "manifestarNfe",
      "title": "Manifestar NFe",
      "centered": "",
      "size": "md"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          ref: "manifestar_nfe_button",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.manifestarNfe
          }
        }, [_vm._v(" Manifestar ")]), _c('b-button', {
          on: {
            "click": function click() {
              _vm.$bvModal.hide('manifestarNfe');
              _vm.statusToManifest = null;
              _vm.manifestoDataSelected = null;
              _vm.manifestoJustify = '';
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": "Selecione o status a manifestar"
    },
    model: {
      value: _vm.statusToManifest,
      callback: function callback($$v) {
        _vm.statusToManifest = $$v;
      },
      expression: "statusToManifest"
    }
  }, _vm._l(_vm.allStatus, function (status) {
    return _c('b-form-select-option', {
      key: status.id + 'status',
      attrs: {
        "value": status.id
      }
    }, [_vm._v(" " + _vm._s(status.description) + " ")]);
  }), 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Justificativa",
      "label-for": "manifestoJustificativa"
    }
  }, [_c(VTextarea, {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.manifestoJustify,
      callback: function callback($$v) {
        _vm.manifestoJustify = $$v;
      },
      expression: "manifestoJustify"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('TableApp', {
    ref: "monitorNfe",
    attrs: {
      "titulo": "Monitor NFe",
      "api-url": "/manifesto/lista",
      "fields": _vm.fields,
      "perPage": 10,
      "multiselect": false
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1font-size-lg",
          attrs: {
            "href": "#"
          }
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])])])]) : _vm._e(), props.field == 'fornecedor' ? _c('span', {
          attrs: {
            "slot": "fornecedor"
          },
          slot: "fornecedor"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('span', {
          staticClass: "text-muted font-weight-bold d-block"
        }, [_vm._v(_vm._s(props.rowData.fornecedor))])])])]) : _vm._e(), props.field == 'data_emissao' ? _c('span', {
          attrs: {
            "slot": "data_emissao"
          },
          slot: "data_emissao"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(props.rowData.data_emissao)) + " ")])]) : _vm._e(), props.field == 'chave_acesso' ? _c('span', {
          attrs: {
            "slot": "chave_acesso"
          },
          slot: "chave_acesso"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('span', {
          staticClass: "text-muted font-weight-bold d-block"
        }, [_vm._v(_vm._s(props.rowData.chave_acesso))])])])]) : _vm._e(), props.field == 'valor_total' ? _c('span', {
          attrs: {
            "slot": "valor_total"
          },
          slot: "valor_total"
        }, [_c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg"
        }, [_vm._v("R$ " + _vm._s(_vm.numberToReal(props.rowData.valor_total, 2)) + " ")])]) : _vm._e(), props.field == 'status' ? _c('div', {
          staticClass: "monitor-status-stack",
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_c('span', {
          class: _vm.statusMonitorClass(props.rowData.status)
        }, [_vm._v(" " + _vm._s(_vm.statusMonitorLabel(props.rowData.status)) + " ")]), _vm.isXmlImportadoEntrada(props.rowData) ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            value: _vm.getXmlImportadoEntradaTooltip(props.rowData),
            expression: "getXmlImportadoEntradaTooltip(props.rowData)",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "monitor-importada-badge"
        }, [_vm._v(" I ")]) : _vm._e()]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [props.rowData.status === 7 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Manifestar',
            expression: "'Manifestar'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.selectManifestarNfe(props.rowData);
            }
          }
        }, [_c('Check', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), props.rowData.status === 4 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Download XML',
            expression: "'Download XML'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "btn btn-sm btn-primary btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.downloadXML(props.rowData.id_manifesto);
            }
          }
        }, [_c('Download', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e(), props.rowData.status === 4 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Exportar para compra',
            expression: "'Exportar para compra'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.exportToCompra(props.rowData.id_manifesto);
            }
          }
        }, [_c('Import', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()])])])]) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };